import {
  Card,
  Form,
  Radio,
  Input,
  Button,
  Space,
  Tooltip,
  message,
  Row,
  Col
} from 'antd'
import { useState } from 'react'
import {
  CloseOutlined,
  PlusCircleOutlined,
  DownloadOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons'
import SupplierSelect from '../../../components/BaseInfoSelects/SupplierSelect'
import ProductListTable from '../../../components/ProductListTable'
import ProductSearchModal from '../../Product/components/ProductSearchModal'
import useProcurementTypeContext from '../hooks/useProcurementTypeContext'
import useOperateAddProductList from '../hooks/useOperateAddProductList'
import * as Utils from '../../../@utils'
import { procurementTypeFundStatus } from '../config'
import { getNumProduct } from '../../../@utils'
import service from '../../../@services'
import '../../../style/card.less'
const maxCount = 999999999
const MAS_PRICE = 99999999
export default function AddProcurement({hide, storeId, freshList = () => {}}) {
  const [loading, setLoading] = useState(false)
  const { isOrder, requestBaseModule, procurementType, procurementTypeText } = useProcurementTypeContext()
  const [supplierId, setSupplierId] = useState(null)
  const {
    rowKey,
    pageData,
    handleSave,
    deleteRecord,
    getProductInfoBySeachModal,
    list,
    setPage,
    uploadBtn,
    otherText
  } = useOperateAddProductList({ supplierId, storeId, type: isOrder?'OrderCostPrice': null })
  const [showAddProductList, setShowAddProductList] = useState(false)

  const downLoadFile = async () => {
    let res = await service.common.getFileTemplate({
      fileType: isOrder
        ? 'purchaseOrderImportProduct'
        : 'purchaseReturnImportProduct'
    })
    let fileName = `${procurementTypeText}商品模板-${Utils.parseTime(
      Date.parse(new Date())
    )}.xlsx`
    Utils.download(res, fileName)
  }
  async function confirmAdd() {
    setLoading(true)
    try {
      await basicForm.validateFields()
      if(!isOrder){
        const flist = list.filter(item=> (item.costPrice == null || +item.costPrice == 0));
        if (flist.length > 0){
           message.error('退款单价不能为空且大于0')
          setLoading(false)
          return
        }
      }
      let purchaseOrderNo = await requestBaseModule.createBill({
        details: list,
        storeId,
        // supplierName: '测试测试',
        ...basicForm.getFieldsValue()
      })
      hide()
      purchaseOrderNo && freshList()
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const [basicForm] = Form.useForm()
  const actionsFooter = (
    <Form form={basicForm}>
      <Form.Item>
        <Space align='end'>
          <Button
            type='primary'
            loading={loading}
            htmlType='submit'
            onClick={confirmAdd}>
            确认
          </Button>{' '}
          <Button onClick={hide}>取消</Button>
        </Space>
      </Form.Item>
    </Form>
  )
  let finalOtherColumns = []
  if (!isOrder) {
    finalOtherColumns = [
      {
        title: '数量',
        dataIndex: 'quantity',
        formatter: (val, record) => {
          val = val && Math.abs(parseInt(val))
          if (val) {
            if(val > record.systemStock){
              message.info(`退货数量大于当前库存进货量上限:${record.systemStock}`);
              return ''
            }
            return val
          } else {
            return ''
          }
        },
      },
      {
        title: (
          <Tooltip title='最近一次采购成本价'>
            <div>
              <span style={{ marginRight: '6px' }}>参考成本价</span>
              <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
            </div>
          </Tooltip>
        ),
        dataIndex: 'refCostPrice'
      },
      {
        title: '退款单价（元）',
        dataIndex: 'costPrice'
      },
      {
        title: '退款总金额（元）',
        dataIndex: 'returnTotalAmount',
        render: (text, record) =>
          record.quantity && record.costPrice
            ? record.quantity * record.costPrice
            : 0
      }
    ]
  } else {
    finalOtherColumns = [
      {
        title: '数量',
        dataIndex: 'quantity',
        formatter: val => {
          val = val && Math.abs(parseInt(val))
          if (val) {
            return val
          } else {
            return ''
          }
        }
      },
      {
        title: (
          <Tooltip title='当前进货成本价,系统默认带出上一次进货价'>
            <div>
              <span style={{ marginRight: '6px' }}>成本价（元）</span>
              <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
            </div>
          </Tooltip>
        ),
        dataIndex: 'costPrice',
        formatter: val => {
          val = val && Math.abs(parseFloat(val))
          if (val) {
            val = val > MAS_PRICE ? MAS_PRICE : val
            let final =
              val == Math.round(val) ? val : Math.round(val * 100) / 100
            return final
          } else {
            return val
          }
        }
      },
      {
        title: '采购金额（元）',
        dataIndex: 'costTotal',
        render: (text, record) =>
          record.quantity && record.costPrice
            ? getNumProduct(record.quantity, record.costPrice)
            : 0
      }
    ]
  }
  const colums = [
    ...finalOtherColumns,
    {
      title: '操作',
      render: (text, record) => (
        <Button size='small' onClick={() => deleteRecord(record)}>
          删除
        </Button>
      )
    }
  ]

  const openModal = () => {
    // 如果是采购进货不用强制判断是否选择了供应商
    if (supplierId || isOrder) {
      setShowAddProductList(true)
    } else {
      message.info('请选择所属供应商')
    }
  }
  const confirmProductList = async _list => {
    await getProductInfoBySeachModal(_list)
    setShowAddProductList(false)
    console.log(setPage);
  }
  return (
    <Card
      extra={<CloseOutlined onClick={hide} />}
      title={!isOrder ? '新增采购退货单' : '新增采购销售单'}
      className='customer-card'
      actions={[actionsFooter]}>
      <Form form={basicForm} initialValues={{ fundStatus: isOrder ? 2 : 4 }}>
        <Row justify='space-between'>
          <Col span={8}>
            <Form.Item
              label='所属供应商'
              name='supplierId'
              rules={[{ required: true, message: '请选择所属供应商' }]}>
              <SupplierSelect onChange={setSupplierId} style={{ width: 160 }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={!isOrder ? '退款状态' : '付款状态'}
              name='fundStatus'>
              <Radio.Group>
                {procurementTypeFundStatus[procurementType].map(item => (
                  <Radio key={item.value} value={item.value}>
                    {item.key}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label='经手人'
              rules={[{ required: true, message: '请填写经手人' }]}
              name='operator'>
              <Input placeholder='请输入' />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div style={{ margin: '0 0 20px', textAlign: 'left' }}>
        <Space>
          <Button
            type='primary'
            icon={<PlusCircleOutlined />}
            onClick={openModal}>
            选择商品
          </Button>
          {uploadBtn}
          <Button
            type='primary'
            icon={<DownloadOutlined />}
            onClick={downLoadFile}>
            下载模板
          </Button>
        </Space>
      </div>
      <ProductListTable
        otherColumns={colums}
        isForReturn={!isOrder}
        pageData={pageData}
        rowKey={rowKey}
        handleSave={handleSave}
        getList={setPage}
        editList={['costPrice', 'quantity']}
      />
      {otherText}
      <Form form={basicForm}>
        <Form.Item
          label='备注'
          name='remark'
          rules={[
            { max: 100, message: '备注不超过100个字符', type: 'string' }
          ]}>
          <Input.TextArea placeholder='请输入备注' row={4} />
        </Form.Item>
      </Form>
      <ProductSearchModal
        storeId={storeId}
        visible={showAddProductList}
        close={() => setShowAddProductList(false)}
        confirmListHaveInfo={confirmProductList}
      />
    </Card>
  )
}
